module.exports = __webpack_public_path__ + "img/Maneki Street_inWallet.1a2d0886.png";